import { render, staticRenderFns } from "./packetList.vue?vue&type=template&id=38820816&scoped=true&"
import script from "./packetList.vue?vue&type=script&lang=js&"
export * from "./packetList.vue?vue&type=script&lang=js&"
import style0 from "./packetList.vue?vue&type=style&index=0&id=38820816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38820816",
  null
  
)

export default component.exports